import styled from "@emotion/styled";
import { Paragraph } from "@polestar/component-warehouse-react";

const PreLinedParagraph = styled(Paragraph)`
  white-space: pre-line;
`;

export default PreLinedParagraph;
